var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 1953.1 385.4",
    style: {
      enableBackground: "new 0 0 1953.1 385.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:url(#Path_1187_00000020389541128193785010000002873842599549866431_)}.st2{fill:url(#Path_1188_00000141434560560945466720000017979000361100030627_)}.st3{fill:url(#Path_1189_00000135654249898931800060000015011415537378740372_)}")), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    d: "M449.7 186c8.6 21.3 43.3 16.4 73-2.1 28.7-17.6 52.9-48.2 49.8-60.8-3.4-14-27.4-31-51.8-42.6-19.8-9.4-39.8-15.3-49.7-13.2-22.1 4.7-38.1 77.5-21.3 118.7",
    style: {
      fill: "none",
      stroke: "#eb71d7",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_1187_00000108994477538626565060000002463490164310993853_",
    gradientUnits: "userSpaceOnUse",
    x1: -221.84,
    y1: 3060.298,
    x2: -222.84,
    y2: 3059.298,
    gradientTransform: "matrix(66.1163 -3.465 3.1722 60.5283 5209.675 -185639.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbab7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f7ce68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    style: {
      fill: "url(#Path_1187_00000108994477538626565060000002463490164310993853_)"
    },
    d: "M247.7 329.7c3.8-10.5-10.3-19.9-26.8-22.8-16.1-3-34.7.1-37.7 5.7-3.3 6.1-.2 20 4.8 32.1 4.1 9.7 9.4 18.3 13.6 20.8 9.4 5.5 38.8-15.5 46.1-35.8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_1188_00000122715275814415141740000016487404970351743121_",
    gradientUnits: "userSpaceOnUse",
    x1: -216.853,
    y1: 2981.557,
    x2: -215.853,
    y2: 2982.53,
    gradientTransform: "matrix(-135.3784 0 0 -123.9339 -27508.227 369894.094)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f77062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fe5196"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    style: {
      fill: "url(#Path_1188_00000122715275814415141740000016487404970351743121_)"
    },
    d: "M1716.1 327.4c-8.9 20.9 18.8 41.7 52.6 49.6 32.5 7.7 70.8 3.3 77.5-7.7 13.4-21.9-13.2-97.9-32-110.1-18.8-12.2-81 27.6-98.1 68.2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_1189_00000070109205760225916040000000629096290817475210_",
    gradientUnits: "userSpaceOnUse",
    x1: -213.799,
    y1: 2936.329,
    x2: -214.799,
    y2: 2935.329,
    gradientTransform: "matrix(-48.2738 0 0 -44.1929 -9133.513 129968.148)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00c6fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005bea"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    style: {
      fill: "url(#Path_1189_00000070109205760225916040000000629096290817475210_)"
    },
    d: "M1188 228.4c-3.2 7.5 6.7 14.9 18.8 17.7 11.5 2.8 25.2 1.2 27.6-2.7 4.8-7.8-4.7-34.9-11.4-39.3-6.7-4.4-28.9 9.8-35 24.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    d: "M1435.3 295.8c-2.7-5.4-11.8-3.3-19.3 2.3-7.2 5.4-12.9 14-11.8 17.3 1.2 3.6 8 7.6 14.7 10.1 5.5 2 10.9 3.1 13.5 2.3 5.8-1.8 8.3-21.5 2.9-32",
    style: {
      fill: "none",
      stroke: "#20dfb2",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    d: "M218.2 121.5c18.6 2.6 29.3-24 28.3-52.5-.8-27.5-12.5-57.1-22.7-60.1-11.2-3.3-33 6.8-51.2 19.3-14.7 10.2-27 22-29.6 29.8-5.8 17.5 39.2 58.6 75.2 63.5",
    style: {
      fill: "#f8f8f8"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.0540a76c6f6323b0f97a26e8bb5b7045.svg";
export { ForwardRef as ReactComponent };